import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

export interface GetAnnouncementAnalyticsRequest {
  id: number
}

export interface AnnouncementAnalytics {
  target: number
  sent: number
  delivered: number
  opened: number
  clicked: number
  deliveryRate: number
  openRate: number
  clickRate: number
}

export const getAnnouncementAnalyticsQueryKey = (data: GetAnnouncementAnalyticsRequest) => [
  'useGetAnnouncementAnalytics',
  data,
]

export const getAnnouncementAnalytics = async (
  data: GetAnnouncementAnalyticsRequest,
  signal?: AbortSignal,
): Promise<AnnouncementAnalytics> => {
  const response = await authAPI.get<AnnouncementAnalytics>(`/communication/analytics/${data.id}`, {
    signal,
  })

  return response.data
}

export const useGetAnnouncementAnalytics = (data: GetAnnouncementAnalyticsRequest) => {
  return useQuery({
    enabled: !!data.id,
    queryFn: ({ signal }) => getAnnouncementAnalytics(data, signal),
    queryKey: getAnnouncementAnalyticsQueryKey(data),
  })
}
